import {
	WarningDialog,
	useGetWarningDialog,
	useIsWarningDialogOpen,
} from '../providers/IssueCreateWarningDialogContextProvider.tsx';

import { useCreateWarningDialogNav } from './useCreateWarningDialogNav.tsx';
import { useGetWarningDialogRetry } from './useGetWarningDialogRetry.tsx';

export const useGetWarningDialogActions = (
	onClose: () => void,
): {
	isWarningDialogOpen: boolean;
	handleConfirm: () => void;
	handleCancel: () => void;
} => {
	const { handleConfirm: navConfirm, handleCancel: navCancel } = useCreateWarningDialogNav(onClose);
	const { handleConfirm: retryConfirm, handleCancel: retryCancel } = useGetWarningDialogRetry();

	const isWarningDialogOpen = useIsWarningDialogOpen();
	const warningDialog = useGetWarningDialog();

	const handleConfirm = warningDialog === WarningDialog.FLOATING ? retryConfirm : navConfirm;
	const handleCancel = warningDialog === WarningDialog.FLOATING ? retryCancel : navCancel;

	return {
		isWarningDialogOpen,
		handleConfirm,
		handleCancel,
	};
};
